import DisplayWrapper from "@/components/wrappers/DisplayWrapper";
import { getApiBaseUrl } from "@/utils/utils";
import dayjs from "dayjs";
import { useState } from "react";
import { useInitializeStaticFiles, useReinitializeStaticFiles } from "../../../common/api/queries";
import { StaticFileModule } from "../enums";
import { StaticFileInitialization } from "../types";
import styles from "./StaticFileFrame.module.scss";

// Without allow-same-origin the module's pages run in an opaque origin, so they can't read the auth token in localStorage.
const IFRAME_SANDBOX = "allow-scripts allow-popups allow-popups-to-escape-sandbox allow-modals";

type Props = {
  module: StaticFileModule;
  title: string;
};

export const StaticFileFrame = ({ module, title }: Props) => {
  const { data: initialization, isError } = useInitializeStaticFiles(module);
  const { mutate: reinitializeStaticFiles } = useReinitializeStaticFiles();

  const [reinitialization, setReinitialization] = useState<StaticFileInitialization>();
  const currentInitialization = reinitialization ?? initialization;

  // The sandbox hides the iframe URL, but a page loaded after the token expired can only be the backend's 401 page,
  // so the module is reopened on its start page with a new token.
  const handleFrameLoad = () => {
    if (currentInitialization && !dayjs().isBefore(currentInitialization.expiresAt)) {
      reinitializeStaticFiles(module, { onSuccess: setReinitialization });
    }
  };

  return (
    <DisplayWrapper itemLoaded={!!currentInitialization} isError={isError}>
      {currentInitialization && (
        <iframe
          className={styles.staticFileFrame}
          src={getApiBaseUrl() + currentInitialization.url}
          title={title}
          sandbox={IFRAME_SANDBOX}
          referrerPolicy="no-referrer"
          onLoad={handleFrameLoad}
        />
      )}
    </DisplayWrapper>
  );
};
